export function extractScannedUrlPathValue(
    value: string,
    expectedPathPrefix: string,
): string | null {
    try {
        const url = new URL(value.trim());
        if (!url.pathname.startsWith(expectedPathPrefix)) {
            return null;
        }

        const pathValue = decodeURIComponent(
            url.pathname.slice(expectedPathPrefix.length),
        );
        if (!pathValue || pathValue.includes('/')) {
            return null;
        }

        return pathValue;
    } catch {
        return null;
    }
}
